import { render, staticRenderFns } from "./AgreementsViewer.vue?vue&type=template&id=53f6aa51&"
import script from "./AgreementsViewer.vue?vue&type=script&lang=js&"
export * from "./AgreementsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports